module.exports = __webpack_public_path__ + "static/media/Publication-screenshot.7bf6f042.png";